import { css } from "@emotion/react";
import type { AccordionProps } from "@mui/material/Accordion";
import MuiAccordion from "@mui/material/Accordion";
import type { AccordionDetailsProps } from "@mui/material/AccordionDetails";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import type { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import { theme } from "@polifonia/theme";

import { MotifIcon } from "@/components/MotifIcon";
import { defineStyles } from "@/internal/emotion";

const styles = defineStyles({
  accordion: css({
    border: `1px solid ${theme.colors.neutral030}`,
    borderRadius: "4px",
    boxShadow: "none",
    marginBottom: "16px",
    "&:before": {
      display: "none",
    },
    "&:last-of-type": {
      marginBottom: 0,
    },
  }),
  accordionSummary: css({
    minHeight: "56px",
    borderRadius: "4px",
    height: "56px",
    "&.Mui-expanded": {
      minHeight: "56px",
      height: "56px",
    },
    [`& .${accordionSummaryClasses.content}`]: {
      margin: "0",
    },
    [`& .${accordionSummaryClasses.content}.Mui-expanded`]: {
      margin: "0",
    },
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
      {
        transform: "rotate(180deg)",
      },
  }),
  accordionDetails: css({
    padding: "16px",
  }),
});

const Accordion: React.FC<AccordionProps> = ({ children, ...props }) => (
  <MuiAccordion css={styles.accordion} {...props}>
    {children}
  </MuiAccordion>
);

const AccordionSummary: React.FC<AccordionSummaryProps> = (props) => (
  <MuiAccordionSummary
    expandIcon={<MotifIcon un-i-motif="arrow_down" />}
    css={styles.accordionSummary}
    {...props}
  />
);

const AccordionDetails: React.FC<AccordionDetailsProps> = (props) => (
  <MuiAccordionDetails css={styles.accordionDetails} {...props} />
);

export { Accordion, AccordionDetails, AccordionSummary };
